import debounce from 'lodash/debounce';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {UploadMessage} from '../locales';

// debouncing so we do not fire off a hundred snackbars
export const notifyOfDuplicateDrop = debounce(() => {
	dispatcher.trigger('app:snackbar', {
		message: UploadMessage.DUPLICATE_FILE_ADDED,
		severity: 'warning',
	});
}, 50);
